import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
	apiKey: window.kaUtion.firebaseApiKey,
	authDomain: window.kaUtion.firebaseAuthDomain,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const googleAuthProvider = new GoogleAuthProvider();

export { app, auth, googleAuthProvider };
